import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Accordion from '../../../../ComponentLibrary/oc-accordion';
import {
  ProofOfOwnerShipImg,
  ProofOfOwnerShipSuccess,
  ProofOfRoofImg,
  ProofOfRoofSuccessImg,
} from '../../../../../../assets/images/warranty-claim';
import styles from './index.module.scss';
import {
  setFormData,
  setStep,
  setAppData,
  saveDocuments,
} from '../../redux/action';
import ReduxFileWidget from '../../helpers/redux-file-widget';
import CTAButton from '../../../../CTAButton';
import { HeaderWrap } from '../../helpers/styles';
import ClaimArea from '../../helpers/claim-area';
import { Subscript, Error } from '../../helpers/styles';
import VideoThumbnails from '../../helpers/video-thumbnails';

const WarrantyDocuments = () => {
  const dispatch = useDispatch();
  const mainState = useSelector(state => state);

  const {
    formData,
    metadata: { pqsResponse, documents },
    isFetching,
    appData: { documentsCount },
  } = mainState;


  const pop = parseInt(formData.proofOfRoofPurchase?.length ?? 0)
  const pos = parseInt(formData.proofOfOwnerShip?.length ?? 0)

  const saveText = documentsCount === (pos + pop) ? 'Next' : 'Save Updates';

  const validated = (formData.proofOfOwnerShip || formData.proofOfRoofPurchase) &&
                    !(documentsCount === (pos + pop)) && !isFetching

  return (
    <>
      <HeaderWrap>
        <h2>Documents</h2>
        <ClaimArea pqsResponse={pqsResponse} />
        <p>
          A claim requires that you submit documentation verifying ownership of
          the property when the shingles were installed.
          Expand the sections for a list of acceptable documents or photographs
          of documents to upload to your claim. Please watch the short video below
          or expand the sections for a list of acceptable documents to upload to your claim.
        </p>
      </HeaderWrap>
      <VideoThumbnails show='proof-of-purchase' mid />
      {documents?.error && (
        <Error
          aria-describedby={'documents'}
          aria-errormessage
          className="error"
          role="alert"
        >
          {documents.error}
        </Error>
      )}
      <Accordion
        label={'Proof of Ownership (Optional)'}
        labelClassName={styles.labelHeader}
        imageSrc={
          formData.proofOfOwnerShip
            ? ProofOfOwnerShipSuccess
            : ProofOfOwnerShipImg
        }
      >
        <h4>Please provide one of the following</h4>
        <ul>
          <li>Property Tax Bill (from the year the shingles were installed)</li>
          <li>Deed (including name & address of property)</li>
          <li>Sales Record (house closing document)</li>
        </ul>
        <ReduxFileWidget
          onChange={files => dispatch(setFormData({ proofOfOwnerShip: files }))}
          fileUploadState={mainState.appData?.proofOfOwnerShip}
          saveFileUploadState={state =>
            dispatch(setAppData({ proofOfOwnerShip: state }))
          }
        />
      </Accordion>
      <Accordion
        label={'Proof of Purchase (Optional)'}
        labelClassName={styles.labelHeader}
        imageSrc={
          formData.proofOfRoofPurchase ? ProofOfRoofSuccessImg : ProofOfRoofImg
        }
      >
        <h4>Please provide one of the following</h4>
        <ul>
          <li>
            Original receipt for material purchased (shingles & roof components)
            - PREFERRED
          </li>
          <li>Contractor’s "paid" invoice (material & labor)</li>
          <li>Building permit (if installed during construction)</li>
          <li>Bill of sale (manufactured home)</li>
        </ul>
        <ReduxFileWidget
          onChange={files =>
            dispatch(setFormData({ proofOfRoofPurchase: files }))
          }
          fileUploadState={mainState.appData?.proofOfRoofPurchase}
          saveFileUploadState={state =>
            dispatch(setAppData({ proofOfRoofPurchase: state }))
          }
        />
      </Accordion>

      { saveText === 'Next' ?
          <CTAButton
          onClick={() => dispatch(setStep(8))}
          data-track="form-advance"
          data-track-form-name="Submit Claim Documents"
          data-track-form-step="step 7 - documents"
          element="button"
          text={saveText}
          type="submit"
        /> :
        <CTAButton
        onClick={() => {

           dispatch(saveDocuments());
        }}
        data-track="form-save"
        data-track-form-name="Submit Claim Documents"
        data-track-form-step="step 7 - documents"
        element="button"
        text={isFetching ? 'Saving...' : saveText}
        type="submit"
        disabled={!validated}
      />
      }

      { saveText === 'Next' &&
        <Subscript
          data-track="form-advance"
          data-track-form-name="Warranty Claim Documents"
          data-track-form-step="step 7 - documents"
          onClick={() => dispatch(setStep(8))}
        >
          Skip this step for now
        </Subscript>
      }
    </>
  );
};

export default WarrantyDocuments;
